!(function (t) {
	var e,
		n,
		o,
		i,
		l,
		a =
			'<svg><symbol id="icon-jiantoushang" viewBox="0 0 1024 1024"><path d="M183.04 610.56a42.282667 42.282667 0 0 0 0 59.733333 42.154667 42.154667 0 0 0 59.648 0L512 400.64l269.312 269.610667a42.154667 42.154667 0 0 0 59.648 0 42.282667 42.282667 0 0 0 0-59.733334L541.866667 311.04a42.154667 42.154667 0 0 0-59.733334 0l-299.093333 299.52z" fill="#A6A6A6" ></path></symbol><symbol id="icon-Othtr_24_jiantou2" viewBox="0 0 1024 1024"><path d="M183.04 413.44a42.282667 42.282667 0 0 1 0-59.733333 42.154667 42.154667 0 0 1 59.648 0L512 623.36l269.312-269.610667a42.154667 42.154667 0 0 1 59.648 0 42.282667 42.282667 0 0 1 0 59.733334l-299.093333 299.52a42.154667 42.154667 0 0 1-59.733334 0L183.04 413.44z" fill="#A6A6A6" ></path></symbol><symbol id="icon-Othtr_24_jiantou1" viewBox="0 0 1024 1024"><path d="M413.44 840.96a42.282667 42.282667 0 0 1-59.733333 0 42.154667 42.154667 0 0 1 0-59.648L623.36 512 353.706667 242.688a42.154667 42.154667 0 0 1 0-59.648 42.282667 42.282667 0 0 1 59.733333 0l299.52 299.093333a42.154667 42.154667 0 0 1 0 59.733334l-299.52 299.093333z" fill="#A6A6A6" ></path></symbol><symbol id="icon-Othtr_40_selected" viewBox="0 0 1024 1024"><path d="M512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m266.8544 322.176a49.7408 49.7408 0 0 0-67.9424-2.9952l-3.2256 2.9952L440.832 593.3568l-124.5184-126.5408a49.7664 49.7664 0 0 0-71.168 0 51.7376 51.7376 0 0 0-2.944 69.0432l2.944 3.2512 160.1024 162.7136a49.7408 49.7408 0 0 0 67.968 2.9952l3.2-2.9952L778.8544 394.496a51.712 51.712 0 0 0 0-72.32z" fill="#FA3123" ></path></symbol><symbol id="icon-Othtr_40_select" viewBox="0 0 1024 1024"><path d="M512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m0 51.2C257.5104 51.2 51.2 257.5104 51.2 512s206.3104 460.8 460.8 460.8 460.8-206.3104 460.8-460.8S766.4896 51.2 512 51.2z" fill="#A6A6A6" ></path></symbol><symbol id="icon-a-36_4_back" viewBox="0 0 1024 1024"><path d="M609.649778 131.299556a59.164444 59.164444 0 0 1 84.053333 0 60.103111 60.103111 0 0 1 0 84.593777L399.502222 512l294.200889 296.106667a60.103111 60.103111 0 0 1 0 84.593777 59.164444 59.164444 0 0 1-84.053333 0L273.408 554.296889a60.103111 60.103111 0 0 1 0-84.593778l336.213333-338.403555z" fill="#1A1A1A" ></path></symbol></svg>',
		d = (d = document.getElementsByTagName('script'))[d.length - 1].getAttribute('data-injectcss'),
		s = function (t, e) {
			e.parentNode.insertBefore(t, e);
		};
	if (d && !t.__iconfont__svg__cssinject__) {
		t.__iconfont__svg__cssinject__ = !0;
		try {
			document.write(
				'<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>'
			);
		} catch (t) {
			console && console.log(t);
		}
	}
	function c() {
		l || ((l = !0), o());
	}
	function m() {
		try {
			i.documentElement.doScroll('left');
		} catch (t) {
			return void setTimeout(m, 50);
		}
		c();
	}
	(e = function () {
		var t, e;
		((e = document.createElement('div')).innerHTML = a),
			(a = null),
			(t = e.getElementsByTagName('svg')[0]) &&
				(t.setAttribute('aria-hidden', 'true'),
				(t.style.position = 'absolute'),
				(t.style.width = 0),
				(t.style.height = 0),
				(t.style.overflow = 'hidden'),
				(e = t),
				(t = document.body).firstChild ? s(e, t.firstChild) : t.appendChild(e));
	}),
		document.addEventListener
			? ~['complete', 'loaded', 'interactive'].indexOf(document.readyState)
				? setTimeout(e, 0)
				: ((n = function () {
						document.removeEventListener('DOMContentLoaded', n, !1), e();
				  }),
				  document.addEventListener('DOMContentLoaded', n, !1))
			: document.attachEvent &&
			  ((o = e),
			  (i = t.document),
			  (l = !1),
			  m(),
			  (i.onreadystatechange = function () {
					'complete' == i.readyState && ((i.onreadystatechange = null), c());
			  }));
})(window);



// WEBPACK FOOTER //
// ./src/assets/iconfont/iconfont.js